import controller from './header-menu-dropdown.controller';

export default {
  bindings: {
    user: '<'
  },
  controller,
  template: require('./header-menu-dropdown.html')
};



// WEBPACK FOOTER //
// src/app/components/header-menu-dropdown/header-menu-dropdown.component.ts